import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { Table, Data } from 'components/layout/Table'
import { Button } from 'components/misc'
import { meta, permissions } from 'helpers/decorators'
import { apiReports } from 'helpers/decorators/api'
import { reports as reportsLayout } from 'constants/layout'
import appConfig from 'config'
import ReactGA from 'react-ga4'
import { ga } from 'constants/misc'
import styles from './reports.styl'
import UpdateReportModal from '../../../components/modals/reports/UpdateReportModal'
import { modal } from 'redux/modules/app'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { HashLink as Link } from 'react-router-hash-link'
import { CircleLoader } from '../../../components/loaders'

@permissions()
@meta({
  title: 'Reports',
  intlKey: 'pageTitle.reports'
})
@apiReports({
  list: true,
  createAuthCodes: true
})
@connect(({ app }) => ({
  locale: app.locale
}), { modal })
class Reports extends Component {
  static propTypes = {
    reports: PropTypes.object,
    locale: PropTypes.object,
    modal: PropTypes.func,
    permissions: PropTypes.object,
    onUpdateReport: PropTypes.func.isRequired
  }

  state = {
    id: null,
    fields: null,
    recentUpdates: null
  }

  handleSubmit = reportCode => {
    ReactGA.event({
      category: ga.CATEGORY,
      action: ga.ACTION_REPORT,
      label: reportCode
    })
  }

  handleOpenModal = (id, fields, recentUpdates) => {
    this.setState(
      {
        id,
        fields,
        recentUpdates
      },
      () => {
        this.props.modal('update-report-modal')
      }
    )
  }

  getReportLinks = (reportsByCategory, groupMap) => {
    let result = []

    for (let key in reportsByCategory) {
      result.push(<li><Link to={`/bo/reports#${key}`} >{get(groupMap[key], 'name')}</Link></li>)
    }

    return result
  }


  getReportCategoryTable = (reportsByCategory, groupMap, loading, authCode, userLocaleParam, permissions) => {
    let result = []

    for (let key in reportsByCategory) {
      const reportList = reportsByCategory[key]
      result.push(
        <div className={styles.reportsCategory} id={key}>
          <h3>{get(groupMap[key], 'name')}</h3><br />
          <Table
            loading={loading}
            length={reportList.length}
            ths={reportsLayout.tableHeaders}
          >
            <Data>
              {reportList.map(({ id, name, translatedDescription, fields, recentUpdates, filename }) => {
                return (
                  <tr key={id}>
                    <td style={{ width: '25%' }}>
                      <span>{get(name, 'translationText')}</span>
                      <p>{translatedDescription}</p>
                    </td>
                    <td style={{ width: '30%' }}>
                      {fields ? <FormattedHTMLMessage
                        id='report_fields'
                        defaultMessage={fields}
                      /> : ''}
                    </td>
                    <td style={{ width: '30%' }}>
                      {recentUpdates ? <FormattedHTMLMessage
                        id='report_recent_updates'
                        defaultMessage= {recentUpdates}
                      /> : ''}
                    </td>
                    <td style={{ width: '10%' }}>
                      <form
                        action={`${appConfig.apiURL}/reports/initialization${userLocaleParam}`}
                        method="POST"
                        target="_blank"
                        onSubmit={() => this.handleSubmit(filename)}
                      >
                        {authCode &&
                          <input
                            type="hidden"
                            name="authorizationCode"
                            value={authCode}
                          />}

                        {permissions.isIfSuper && <Button style={{ marginRight: '10px'}}
                                                          type="button"
                                                          intlKey="button.edit"
                                                          small
                                                          onClick={() => this.handleOpenModal(id, fields, recentUpdates)}
                        >
                          Edit
                        </Button>}

                        {id && <input type="hidden" name="reportId" value={id} />}
                        <Button
                          type="submit"
                          intlKey="button.run"
                          disabled={!authCode}
                          small
                        >
                          Run
                        </Button>

                      </form>
                    </td>
                  </tr>
                )
              })}
            </Data>
          </Table>
          <UpdateReportModal
            modalId="update-report-modal"
            reportId={this.state.id}
            fields={this.state.fields}
            recentUpdates={this.state.recentUpdates}
            onUpdateReport={this.props.onUpdateReport}
          />
        </div>)
    }

    return result
  }

  render() {
    const { reports: { loading, list, authCode }, locale, permissions } = this.props

    const userLocaleParam = get(locale, 'code') ? `?locale=${locale.code}` : ''

    let groupMap = {}

    const reportsByCategory = list.reduce((reportsByCategory, item) => {
      const group = (reportsByCategory[item.category.value] || [])
      group.push(item)
      reportsByCategory[item.category.value] = group
      groupMap[item.category.value] = { id: item.category.value, name: item.category.translationText }
      return reportsByCategory
    }, {})

    return(<div className={styles.reportWrapper}>
        <div className={styles.reportDescription}>
          <h2>
            <FormattedMessage
              tagName="p"
              id="label.report_overview"
              defaultMessage="Overview"
            />
          </h2>
          <FormattedMessage
            tagName="p"
            id="label.report_description"
            defaultMessage="Fields included and Recent updates are currently only available in English. We are looking at solutions to allow them to be available in other languages."
          />
        </div>
        {loading ? (
            <div className={styles.loader}>
              <CircleLoader size={50} />
            </div>) :
          (<div>
            <div className={styles.reportOverview}>
              <ul>
                {this.getReportLinks(reportsByCategory, groupMap)}
              </ul>
            </div>

            { this.getReportCategoryTable(reportsByCategory, groupMap, loading, authCode, userLocaleParam, permissions) }
          </div>)}
      </div>
    )
  }
}

export default Reports
